export const blocksToText = (blocks = []) =>
  blocks
    .map((b) => {
      if (b.type === "h") return `## ${b.text ?? ""}`;
      if (b.type === "quote") return `> ${b.text ?? ""}${b.by ? ` — ${b.by}` : ""}`;
      if (b.type === "image") return `![${b.caption ?? ""}](${b.src ?? ""})`;
      return b.text ?? "";
    })
    .join("\n\n");

export const textToBlocks = (text = "") =>
  text
    .split(/\n\s*\n/)
    .map((s) => s.trim())
    .filter(Boolean)
    .map((s) => {
      const img = s.match(/^!\[(.*)\]\((.+)\)$/);
      if (img) return { type: "image", caption: img[1], src: img[2] };
      if (s.startsWith("## ")) return { type: "h", text: s.slice(3).trim() };
      if (s.startsWith("> ")) {
        const [quote, by] = s.slice(2).split(" — ");
        return { type: "quote", text: quote.trim(), by: by?.trim() || null };
      }
      return { type: "p", text: s.replace(/\n/g, " ") };
    });
